// extracted by mini-css-extract-plugin
export default {"bio":"AboutUs_bio__tA-ua","bio_item":"AboutUs_bio_item__tRDhE","image_logo":"AboutUs_image_logo__L+esN"};